import { useCallback, useEffect, useState } from 'react';

import type { SalaryFormat } from '@app/api/ClientServices';
import { SALARY_PERCENT } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/data';
import type { UseServiceSalaryComponentProps } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent/types';

export const useServiceSalaryComponent = ({
  onSalaryTypeSelect,
  serviceId,
  onSalaryValueChange,
  defaultSalaryFormat,
}: UseServiceSalaryComponentProps) => {
  const [salaryType, setSalaryType] =
    useState<SalaryFormat>(defaultSalaryFormat);

  useEffect(() => {
    setSalaryType(defaultSalaryFormat);
  }, [defaultSalaryFormat]);

  const getSalaryIcon = useCallback(() => {
    switch (salaryType) {
      case SALARY_PERCENT:
        return '%';
      default:
        return '';
    }
  }, [salaryType]);

  const handleSAlaryTypeChange = useCallback(
    (value?: SalaryFormat) => {
      if (value) {
        setSalaryType(value);
        onSalaryTypeSelect(value, serviceId);
      }
    },
    [onSalaryTypeSelect, serviceId]
  );

  const handleSAlaryValueChange = useCallback(
    (value?: string) => {
      if (value) {
        onSalaryValueChange(value, serviceId);
      }
    },
    [onSalaryValueChange, serviceId]
  );

  return {
    handleSAlaryTypeChange,
    getSalaryIcon,
    salaryType,
    handleSAlaryValueChange,
  };
};
